import { submitFormRequest, updateFormProcedure } from '@store';
import { Formik } from 'formik';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { FormField } from '@components';
import { ApiEndpoint, ApiType, FormActionType, FormType, InputType, Translation } from '@enums';
import { useAppDispatch, useFormLoadingStatus, useFormSubmissionStatus } from '@hooks';
import { useTranslation } from 'react-i18next';

interface RuleStatusSelectProps {
  value: string;
  rule_id: string | number;
  options: any;
}

export const RuleStatusSelect: React.FC<RuleStatusSelectProps> = ({ value, rule_id, options }) => {
  const dispatch = useAppDispatch();
  const { id: application_id } = useParams();

  const { t: tForm } = useTranslation(Translation.Configuration, { keyPrefix: 'forms.waf.ruleSets' });

  const formType = FormType.CdnWAF;
  const endpoint = ApiEndpoint.RULE;

  const formLoading = useFormLoadingStatus({ formType, endpoint });
  const formSubmitting = useFormSubmissionStatus({ formType, endpoint });
  const disabled = formLoading || formSubmitting;

  const initialValues = useMemo(
    () => ({
      rule_status: value,
    }),
    [value],
  );

  return (
    <Formik initialValues={initialValues} onSubmit={() => {}} enableReinitialize>
      {({ values }) => (
        <FormField
          centerItem
          name="rule_status"
          placeholder={tForm('selectYourRuleStatus')}
          inputType={InputType.Select}
          options={options}
          value={values.rule_status}
          disabled={disabled}
          onChange={(e) => {
            const updatedStatus = e.target.value;

            const formData = {
              rule_status: updatedStatus,
            };

            dispatch(updateFormProcedure({ formType, procedure: FormActionType.Update }));
            dispatch(
              submitFormRequest({
                formType,
                params: { content_id: rule_id, application_id },
                formData: formData,
                globalOptions: {
                  endpoint,
                  refetch_id: application_id,
                  refetch_endpoint: endpoint,
                  returnResult: true,
                  apiType: ApiType.PUT,
                },
              }),
            );
          }}
        />
      )}
    </Formik>
  );
};
